<template lang="pug">
.homepageSection1Component
  .sectionContainer
    .left
      .gradesList
        .item._active для 1-го класса
        .item 2-4 классы в разработке
        .emblem
          img.img(src="assets/images/home/school-emblem.svg")
          .hint По системе «Школа России»
      .title Поможем легко и правильно объяснить любую тему по математике и&nbsp;русскому&nbsp;языку
      .buttons
        purchase-buttons-block(:is-last-section="false")
    .right
      .image
        .cloud._1(
          :style="cloud1Styles"
          data-aos="zoom-in"
          data-aos-delay="1000"
        )
          .text Как же мне это ему объяснить?
            .emoji
        .cloud._2(
          :style="cloud2Styles"
          data-aos="zoom-in"
          data-aos-delay="800"
        )
          .text Нам в классе объясняли #[br ] по-другому!
            .emoji
</template>

<script>
import PurchaseButtonsBlock from './PurchaseButtonsBlock/PurchaseButtonsBlock'
import { computed } from 'vue'

export default {
  components: {
    PurchaseButtonsBlock
  },
  props: {
    cursor: {
      type: Object,
      default: () => ({ x: 0, y: 0 })
    }
  },
  setup (props) {
    const cloud1Styles = computed(() => ({
      margin: `-${props.cursor.y * 30}px -${props.cursor.x * 30}px`
    }))
    const cloud2Styles = computed(() => ({
      margin: `${props.cursor.y * 30}px ${props.cursor.x * 30}px`
    }))

    return {
      cloud1Styles,
      cloud2Styles
    }
  }
}
</script>

<style lang="sass" scoped>
.homepageSection1Component
  background: #ECF4F9 center no-repeat url('~@/assets/images/home/block1-circles.svg')
  > .sectionContainer
    display: grid
    grid-template-columns: repeat(2, 1fr)
    grid-template-areas: "text image"
    > .left
      padding: 18*$u 30*$u 15*$u 0
      grid-area: text
      display: flex
      flex-direction: column

      > .gradesList
        position: relative
        display: flex
        align-items: center
        flex-wrap: wrap
        margin: -2*$u
        margin-bottom: 5*$u
        @media (max-width: $padWidth)
          padding-right: 80px

        > .item
          font-family: GolosTextWebBold, serif
          font-style: normal
          font-weight: bold
          font-size: 12px
          line-height: 14px
          color: #0B5DD8
          padding: 1*$u 3*$u
          margin: 2*$u
          white-space: nowrap

          &._active
            color: #FFFFFF
            background: #0B5DD8
            border-radius: 28px

        > .emblem
          position: absolute
          top: 50%
          right: 0
          width: 100px
          z-index: 1
          transform: translate(100%, -50%)
          @media (max-width: $XLWidth)
            transform: translate(0, -50%)
          @media (max-width: $padWidth)
            width: 80px

          .img
            width: 100%

          .hint
            position: absolute
            display: block
            top: 50%
            right: calc(100% + 2*#{$u})
            transform: translate(0, -50%)
            white-space: nowrap
            background: $cWhite
            border-radius: $brS
            padding: 3*$u
            font-size: 14px
            font-family: GolosTextWebRegular, serif
            color: $cBlack
            line-height: 1
            box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3)
            opacity: 0
            pointer-events: none
            transition: $animationSpeed

          &:hover
            .hint
              opacity: 1

      > .title
        font-family: GolosTextWebBold, serif
        font-style: normal
        font-weight: bold
        font-size: 38px
        line-height: 1.2
        color: $cDarkBlue
        margin-bottom: auto
        //padding-right: 8*$u

      > .buttons
        margin-right: 15*$u
        margin-bottom: 5*$u

    > .right
      display: flex
      align-items: flex-start
      justify-content: center
      overflow: hidden
      grid-area: image

      > .image
        width: 644px
        height: 491px
        flex: 0 0 644px
        background: center no-repeat url('~@/assets/images/home/block1-background.jpg')
        background-size: contain
        position: relative

        > .cloud
          padding: 4*$u 4*$u
          background: rgba(white, .5)
          backdrop-filter: blur(9px)
          position: absolute

          > .text
            font-family: GolosTextWebRegular, serif
            font-style: normal
            font-weight: normal
            font-size: 12px
            line-height: 20px
            color: #FFFFFF
            white-space: nowrap

            > .emoji
              display: inline-block
              width: 5*$u
              height: 5*$u
              background: center no-repeat
              background-size: contain
              position: relative
              top: 4px
              margin-left: 4px

          &._1
            border-radius: 30px 30px 4px 30px
            top: 16*$u
            left: 75*$u

            > .text
              > .emoji
                background-image: url('~@/assets/images/home/block1-emoji-surprise.png')

          &._2
            border-radius: 4px 30px 30px 30px
            top: 50*$u
            left: 45*$u

            > .text
              > .emoji
                background-image: url('~@/assets/images/home/block1-emoji-anguish.png')

  @media (max-width: 1400px)
    > .sectionContainer
      > .left
        > .title
          font-size: 32px
          margin-bottom: 12*$u
          margin-top: 5*$u

  @media (max-width: 1016px)
    > .sectionContainer
      > .right
        > .image
          left: -10*$u

  @media (max-width: $XLWidth)
    > .sectionContainer
      grid-template-columns: 100%
      grid-template-areas: "image" "text"
      > .left
        padding-right: 0
        > .buttons
          margin: 0

      > .right
        height: 420px
        align-items: flex-start

        > .image
          width: 838px
          height: 638px
          flex: 0 0 838px
          left: 0
          margin-top: -10px

          > .cloud
            &._1
              top: 10*$u
              left: 100*$u
            &._2
              left: 60*$u

  @media (max-width: 630px)
    > .sectionContainer
      > .left
        padding: 12*$u 0

        > .gradesList
          margin-bottom: 4*$u

        > .title
          font-size: 24px
          margin-bottom: 7*$u
          margin-top: 0

      > .right
        > .image
          width: 558px
          height: 425px

          > .cloud
            &._1
              top: 10*$u
              left: 80*$u
            &._2
              left: 87*$u
              top: 63*$u
</style>
